
























































import { Component, Vue } from "vue-property-decorator";
import {Getter} from "vuex-class";
import {db, contactsCollection, Timestamp} from "../../db";
import { Message } from "../../models";
import * as _ from 'lodash';

@Component
export default class Messages extends Vue {
    @Getter messages;
    @Getter contacts;

    private search = '';

    private headers = [
        {
            text: 'Status',
            value: 'read',
        },
        { text: 'Created', value: 'created' },
        { text: 'Contact', value: 'contact'},
        { text: 'Subject', value: 'subject' },
        { text: 'Message', value: 'message' },
        { text: 'Add', value: 'addContact' },
        { text: 'Delete', value: 'delete' },
    ];

    async messageStatus(msg) {
        await db.doc(`messages/${msg.id}`).update({read: msg.read})
    }

    async messageDelete(msg) {
        await db.doc(`messages/${msg.id}`).delete()
    }

    async addContact(item: Message) {
        await contactsCollection.add({
            firstName: item.firstName,
            lastName: item.lastName,
            phone: item.phone,
            email: item.email,
            created: Timestamp.now(),
        });
    }

    IsContact(item: Message): boolean {
        return _.some(this.contacts, (x) => x.firstName == item.firstName && x.lastName == item.lastName);
    }

    formatCreated( msg) {
        if( msg.created ) {
            const date = msg.created.toDate()
            if( date.getFullYear() != 1969) {
                return date.toLocaleDateString();
            }
        }
        return 'N/A';
    }
}
